var _defs, _path, _path2, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _path3, _g9, _g10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogins(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 21.989,
    viewBox: "0 0 32 21.989",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ffe07d;}.b{fill:#ffd064;}.c{fill:#e4f6ff;}.d{fill:#d3effb;}.e{fill:#f4fbff;}.f{fill:#2b4d66;}.g{fill:#b3e59f;}.h{fill:#95d6a4;}.i{fill:#78c2a4;}.j{fill:#365e7d;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M188.9,123.695V103.347h-14.52v20.348l.66.188h12.9Z",
    transform: "translate(-163.479 -101.893)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M345.677,103.347v20.535h2.857l.957-.187V103.347Z",
    transform: "translate(-324.072 -101.893)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.434)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M151.595,80.087h15.341v2.124h-13.86v19.865h-1.481a.644.644,0,0,1-.644-.644v-20.7A.644.644,0,0,1,151.595,80.087Z",
    transform: "translate(-150.951 -80.087)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.434 1.033)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M151.984,96.93v19.221a.322.322,0,0,1-.322.322h-.711v.448a.644.644,0,0,0,.644.644h1.481V97.7h13.86V96.608h-14.63A.322.322,0,0,0,151.984,96.93Z",
    transform: "translate(-150.951 -96.608)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.462)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M391.388,102.076H398.3a.625.625,0,0,0,.625-.625V80.712a.625.625,0,0,0-.625-.625h-6.913Z",
    transform: "translate(-391.388 -80.087)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.188)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M469.2,80.087H467.01v21.989H469.2a.625.625,0,0,0,.625-.625V80.712A.625.625,0,0,0,469.2,80.087Z",
    transform: "translate(-467.01 -80.087)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.877 10.528)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M448.037,249.5h-1.525a.483.483,0,1,1,0-.966h1.525a.483.483,0,1,1,0,.966Z",
    transform: "translate(-446.029 -248.53)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 5.956)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M15.964,175.387A18.811,18.811,0,0,0,.009,189.7a.29.29,0,0,0,.491.269,16.684,16.684,0,0,1,15.465-4.647Z",
    transform: "translate(0 -175.387)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 12.115)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M1.476,278.024a18.659,18.659,0,0,0-1.468,4.047.29.29,0,0,0,.491.269,16.684,16.684,0,0,1,15.465-4.647V274.3a16.683,16.683,0,0,0-14.488,3.725Z",
    transform: "translate(0 -273.921)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.735 3.912)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M243.338,149.831l-7.158-7.08a.25.25,0,0,0-.426.178v14.16a.25.25,0,0,0,.426.178l7.158-7.08A.25.25,0,0,0,243.338,149.831Z",
    transform: "translate(-235.754 -142.679)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M243.338,225.27l-2.147-2.124-5.437,5.378v4a.25.25,0,0,0,.426.178l7.158-7.08A.25.25,0,0,0,243.338,225.27Z",
    transform: "translate(-221.019 -214.205)"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.708 9.902)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M427.325,239.625a1.109,1.109,0,0,0,2.107.483,1.385,1.385,0,0,1-.141-.454,1.925,1.925,0,0,1,.141-.51,1.109,1.109,0,0,0-2.108.481Z",
    transform: "translate(-427.325 -238.516)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.801 9.995)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M430.284,240.015a1.108,1.108,0,0,1-1.46,1.46,1.108,1.108,0,1,0,1.46-1.46Z",
    transform: "translate(-428.824 -240.015)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogins);
export default __webpack_public_path__ + "static/media/logins.0687ac992166f65afada921ac9c41f4f.svg";
export { ForwardRef as ReactComponent };